// src/config/themeConfig.ts

// Import assets so webpack packs them and returns proper URLs, regardless of type (svg/png/etc.)
// Halliburton
// Note: paths are relative to this file (src/config/...)
// The following imports work for both svg and png assets.
import HALLIBURTON_LOGO from '../assets/svg/InteLift.svg';
import HALLIBURTON_ICON from '../assets/svg/H.svg';
// Evinsys
import EVINSYS_LOGO from '../assets/svg/OptiLynx.svg';
import EVINSYS_ICON from '../assets/svg/sygnet.png';

export interface Theme {
  color: string;
  logo: string;
  icon: string;
  footerBrandLogo?: string;
  companyName?: string;
  companyUrl?: string;
  footerPoweredByText?: string;
  title: string;
  fontFamily: string;
  fontWeights: {
    light: number;
    regular: number;
    bold: number;
  };
  primeReact: {
    theme: string;
    fontFamily: string;
    buttonFontWeight: number;
    headerFontWeight: number;
    labelFontWeight: number;
  };
}

export const themes: { [key: string]: Theme } = {
  halliburton: {
    color: '#c00',
    logo: HALLIBURTON_LOGO,
    icon: HALLIBURTON_ICON,
    // Use file served from public to avoid svgr parsing
    footerBrandLogo: '/assets/img/halliburton_bottom.svg',
    companyName: 'Halliburton',
    companyUrl: 'https://www.halliburton.com/',
    footerPoweredByText: 'Powered by',
    title: 'Intelevate® Edge Devices Management System',
    fontFamily: 'Univers, -apple-system, BlinkMacSystemFont, sans-serif',
    fontWeights: {
      light: 300,
      regular: 400,
      bold: 700
    },
    primeReact: {
      theme: 'lara-light-indigo',
      fontFamily: 'Univers, -apple-system, BlinkMacSystemFont, sans-serif',
      buttonFontWeight: 700,
      headerFontWeight: 700,
      labelFontWeight: 700
    }
  },
  evinsys: {
    color: '#2480F7',
    logo: EVINSYS_LOGO,
    icon: EVINSYS_ICON,
    footerBrandLogo: EVINSYS_LOGO,
    companyName: 'Evinsys',
    companyUrl: 'https://www.evinsys.com/',
    footerPoweredByText: 'Powered by',
    title: 'OptiLynx, Edge Devices Management System',
    fontFamily: 'Univers, -apple-system, BlinkMacSystemFont, sans-serif',
    fontWeights: {
      light: 300,
      regular: 400,
      bold: 700
    },
    primeReact: {
      theme: 'lara-light-indigo',
      fontFamily: 'Univers, -apple-system, BlinkMacSystemFont, sans-serif',
      buttonFontWeight: 700,
      headerFontWeight: 700,
      labelFontWeight: 700
    }
  },
  // Add more clients as needed
};

// This is the single source of truth for which theme is being used.
// It reads the client name from env with a sensible default.
export const currentThemeName: string = (process.env.REACT_APP_CLIENT_NAME || 'halliburton').toLowerCase();
export const currentTheme: Theme = themes[currentThemeName] || themes.halliburton;

// Some places still import a color constant for quick styling; keep export for compatibility.
export const defaultThemeColor = currentTheme.color;

export default themes;
